import styled from "styled-components";
export const ServiceContainer = styled.div`
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #ffff;
    color: #ffff;
    margin-bottom:20px;
    @media screen and (max-width: 768px) {
        height: 110px;
    }
    @media screen and (max-width: 480px) {
        height: 1300px;
    } ;
`;
export const ServicesWrapper = styled.div`
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
    }
    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20 px;
    }
`;
export const ServicesCard = styled.div`
    width: 300px;
    margin-bottom:20%;
    background: #112540;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 5px 5px 10px #1e293b, -5px -5px 10px #1e293b;
    transition: all 0.2 ease-in-out;
    @media only screen and (min-width: 640px) {
        height: 300px;
    }
    @media only screen and (max-width: 640px) {
        height: 200px;
    }
    &:hover {
        transform: translateY(-10px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
            0 6px 6px rgba(0, 0, 0, 0.23);
        transition: all 0.3s ease-in-out;
        cursor: pointer;
    }
`;

export const ServicesIcon = styled.img`
  height: 150px;
  width: 200px;
  text-align: center;
  margin: -20px auto;
  border-radius:15px;
`;
export const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 64px;
  margin-top: 20px;
  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;
export const ServicesH2 = styled.h2`
    font-size: 1rem;
    font-weight: bold;
    margin-top:20px;


`;
